import { BusinessCategory, BusinessCategoryData } from './index';
import { ReadCollectionGql } from './gql';

type Data = {
  documents: BusinessCategoryData[];
  nextToken: string;
};

class BusinessCategoryCollection {

  readonly documents: BusinessCategory[];
  readonly nextToken: string;

  constructor(data: Data = { documents: [], nextToken: '' }) {
    this.documents = data.documents.map(it => new BusinessCategory(it));
    this.nextToken = data.nextToken;
  }

  async readAll(): Promise<this> {
    let collection = this;
    while (collection.nextToken) {
      const gql = await new ReadCollectionGql().fetch({ nextToken: collection.nextToken });
      if (!gql.result) throw new Error('invalid result');
      collection = collection.merge(new BusinessCategoryCollection(gql.result));
    }
    return collection;
  }

  merge(collection: BusinessCategoryCollection): this {
    const documents = BusinessCategory.sort([...this.documents, ...collection.documents]);
    const nextToken = collection.nextToken;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents, nextToken });
  }

  add(category: BusinessCategory): this {
    const documents = BusinessCategory.sort([...this.documents, category]);
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents });
  }

  replace(category: BusinessCategory): this {
    const documents = BusinessCategory.sort(this.documents.map(it => it.id === category.id ? category : it));
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents });
  }

  remove(category: BusinessCategory): this {
    const documents = this.documents.filter(it => it.id !== category.id);
    return Object.assign(Object.create(this.constructor.prototype), { ...this, documents });
  }

  toJSON(): Data {
    const { nextToken } = this;
    const documents = this.documents.map(it => it.toJSON());
    return { documents, nextToken };
  }

  static async read(): Promise<BusinessCategoryCollection> {
    const gql = await new ReadCollectionGql().fetch();
    if (!gql.result) throw new Error('invalid result');
    return new BusinessCategoryCollection(gql.result);
  }

}

export { BusinessCategoryCollection };
export type { Data as BusinessCategoryCollectionData };